import { administratorRoles } from "../config/roles";
import { ListDefinition } from "./listDefinition.types";

const recordRoute = "/fixture";

/**
 * The fixtures list. Paged by the search endpoint, the only read the warehouse offers,
 * and read on arrival as the legacy table did. Start and end are shown as stored, in
 * local time. The less-used filters sit behind Advanced filters.
 */
export const fixturesListDefinition: ListDefinition = {
  path: "/fixtures",
  entityName: "dwfixture",
  recordRoute,
  title: "Fixtures",
  allowedRoles: administratorRoles,
  data: "search-paged",
  searchOnLoad: true,
  // Lower case: the repository reads these keys from a case-sensitive dictionary.
  filters: [
    { name: "name", label: "Name", kind: "text", width: "wide" },
    { name: "fixturestart", label: "Start", kind: "date-range" },
    {
      name: "seasonid",
      label: "Season",
      kind: "lookup",
      lookupEntity: "dwseason",
      searchable: true,
      width: "wide",
    },
    {
      name: "opponentid",
      label: "Opponent",
      kind: "lookup",
      lookupEntity: "dwopponent",
      searchable: true,
      width: "wide",
    },
    {
      name: "teamid",
      label: "Team",
      kind: "lookup",
      lookupEntity: "dwteam",
      searchable: true,
    },
    {
      name: "homestatusid",
      label: "Venue Status",
      kind: "lookup",
      lookupEntity: "dwhomestatus",
      searchable: true,
      advanced: true,
    },
    {
      name: "fixturegradeid",
      label: "Fixture Grade",
      kind: "lookup",
      lookupEntity: "dwfixturegrade",
      searchable: true,
      advanced: true,
    },
    {
      name: "competitionstageid",
      label: "Competition Stage",
      kind: "lookup",
      lookupEntity: "dwcompetitionstage",
      searchable: true,
      advanced: true,
    },
    {
      name: "seasonalperiodid",
      label: "Seasonal Period",
      kind: "lookup",
      lookupEntity: "dwseasonalperiod",
      searchable: true,
      advanced: true,
    },
  ],
  filterByStatus: false,
  allowAdd: true,
  addRoles: administratorRoles,
  allowStatusEdit: false,
  allowDelete: true,
  deleteRoles: administratorRoles,
  columns: [
    {
      key: "Name",
      label: "Name",
      width: 300,
      sortable: true,
      link: { to: recordRoute, idKey: "Id", newTab: "button" },
    },
    {
      key: "fixturedescription",
      label: "Description",
      width: 300,
      sortable: true,
    },
    {
      key: "fixturestart",
      label: "Start",
      width: 200,
      display: "local-datetime",
      sortable: true,
    },
    {
      key: "fixtureend",
      label: "End",
      width: 200,
      display: "local-datetime",
      sortable: true,
    },
    {
      key: "homestatusidname",
      label: "Venue Status",
      width: 200,
      sortable: true,
      link: { to: "/venue-status", idKey: "homestatusid", newTab: "button" },
    },
    {
      key: "seasonidname",
      label: "Season",
      width: 200,
      sortable: true,
      link: { to: "/season", idKey: "seasonid", newTab: "button" },
    },
    {
      key: "opponentidname",
      label: "Opponent",
      width: 200,
      sortable: true,
      link: { to: "/opponent", idKey: "opponentid", newTab: "button" },
    },
    {
      key: "teamidname",
      label: "Team",
      width: 200,
      sortable: true,
      link: { to: "/team", idKey: "teamid", newTab: "button" },
    },
    {
      key: "fixturegradeidname",
      label: "Fixture Grade",
      width: 200,
      sortable: true,
      link: { to: "/fixture-grade", idKey: "fixturegradeid", newTab: "button" },
    },
    {
      key: "competitionidname",
      label: "Competition",
      width: 200,
      sortable: true,
      link: { to: "/competition", idKey: "competitionid", newTab: "button" },
    },
    {
      key: "competitionstageidname",
      label: "Competition Stage",
      width: 200,
      sortable: true,
      link: { to: "/competition-stage", idKey: "competitionstageid", newTab: "button" },
    },
    {
      key: "lastseasonfixtureidname",
      label: "Last Season Fixture",
      width: 200,
      sortable: true,
      link: { to: "/fixture", idKey: "lastseasonfixtureid", newTab: "button" },
    },
    {
      key: "seasonalperiodidname",
      label: "Seasonal Period",
      width: 200,
      sortable: true,
      link: { to: "/seasonal-period", idKey: "seasonalperiodid", newTab: "button" },
    },
    {
      key: "ontv",
      label: "On TV",
      width: 200,
      display: "yesno-badge",
      sortable: true,
    },
    {
      key: "createdon",
      label: "Created On",
      width: 200,
      display: "datetime",
      sortable: true,
    },
    {
      key: "modifiedon",
      label: "Modified On",
      width: 200,
      display: "datetime",
      sortable: true,
    },
  ],
};
